export default "__VITE_ASSET__DZljgkwA__"